import { AuthState } from "@/context/AuthProvider";

import Forbidden from "./components/Error/Forbidden";
import { useState } from "react";

// A wrapper for <Route> that redirects to the home
// screen if you're not yet authenticated.

export default function PrivateRoute(props: PrivateRouteProps) {
  const { children, authState, requiredRolle } = props;
  const [forwarding, setForwarding] = useState(false);

  if (authState.state === "LOADING") {
    return <div></div>;
  }

  const roller = authState.bruger ? authState.bruger.roller : [];
  const hasRequiredRolle =
    !requiredRolle ||
    roller.findIndex((role) => role.navn === requiredRolle) > -1;

  // If user is not logged in
  if (authState.state === "UNAUTHORIZED") {
    if (!forwarding) {
      setForwarding(true);
      const { pathname, search } = window.location;
      forward(pathname, search);
    }
    return (
      <div style={{ marginTop: 100, marginLeft: 100 }}>
        Sender dig til DMP for autenticering ...
      </div>
    );
  }
  // If the user is logged in, but does not have the required rolle
  // TODO: Instead of changing the HOME route to show forbidden, create a 500 page
  else if (!hasRequiredRolle || authState.state === "FORBIDDEN") {
    return <Forbidden />;
  }

  // Else everything is good
  return <>{children}</>;
}

interface PrivateRouteProps {
  children: React.ReactNode;
  authState: AuthState;
  requiredRolle?: string;
}
function forward(pathname: string, search: string) {
  window.location.href = `/auth/login?returnurl=${encodeURIComponent(
    pathname
  )}${encodeURIComponent(search)}`;
}
